module.exports = __webpack_public_path__ + "media/src/images/partners/htw_berlin-ec5f93d74a772670def6920995cb9044.jpg";